<template>
  <div class="p-3">
    <ImagesView :change-permission="'change_inventoryitem'" :inventory-uuid="inventory.uuid"/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ImagesView from "../../../inventory/view/images/ImagesView";

  const {mapState} = createNamespacedHelpers('inventory');

  export default {
    name: "Images",
    components: {ImagesView},
    data() {
      return {
      };
    },
    computed: {
      ...mapState({
        inventory: state => state.view.currentInventory
      })
    },
    methods: {}
  }
</script>

<style lang="scss" scoped>
</style>
